import { useEffect, useRef } from "react";
import { useHudStore } from "../store/hudStore";
import Loading from "../screens/Loading";
import Login from "../screens/Login";
import Hud from "../screens/Hud";
import Main from "../screens/Main";
import Domain from "../screens/Domain";
import Character from "../screens/Character";
import Focus from "../screens/Focus";
import Vault from "../screens/Vault";
import Quest from "../screens/Quest";
import Debt from "../screens/Debt";
import Account from "../screens/Account";
import Expense from "../screens/Expense";
import QuestLog from "../screens/QuestLog";
import Settings from "../screens/Settings";
import Soon from "../screens/Soon";
import Overlays from "../components/overlays/Overlays";

// App shell = the old render() screen switch. `screen` lives in the store; each
// screen is a component. Overlays (level-up / main-done / badge) mount in Phase E.
export default function App() {
  const screen = useHudStore((s) => s.screen);
  const boot = useHudStore((s) => s.boot);
  const live = useHudStore((s) => s.live);
  const routeKey = useHudStore((s) => [s.screen, s.questId, s.main, s.domain, s.debtId, s.accountId, s.expenseId, s.noteId].join(":"));
  const content = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (screen === "loading" || screen === "login") return;
    window.scrollTo({ top: 0, behavior: "instant" });
    content.current?.focus({ preventScroll: true });
  }, [routeKey, screen]);

  // Boot once (guarded against React StrictMode's double-invoke in dev).
  const booted = useRef(false);
  useEffect(() => {
    if (booted.current) return;
    booted.current = true;
    void boot();
  }, [boot]);

  if (screen === "loading") return <Loading />;
  if (screen === "login" || !live || !sessionStorage.getItem("access_token")) return <Login />;
  const body =
    screen === "hud" ? <Hud /> :
    screen === "main" ? <Main /> :
    screen === "domain" ? <Domain /> :
    screen === "character" ? <Character /> :
    screen === "focus" ? <Focus /> :
    screen === "vault" ? <Vault /> :
    screen === "quest" ? <Quest /> :
    screen === "debt" ? <Debt /> :
    screen === "account" ? <Account /> :
    screen === "expense" ? <Expense /> :
    screen === "log" ? <QuestLog /> :
    screen === "settings" ? <Settings /> :
    <Soon />; // soon
  // Min-height + flex column so the active screen (flex:1) fills the viewport and
  // keeps its own in-column footer at the bottom (sticky footer).
  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <div id="main-content" ref={content} role="main" tabIndex={-1} className="app-content">{body}</div>
      <Overlays />
    </div>
  );
}
